import React from 'react'
import { Head } from '@shared/components/head'

import { PageMeta, PageMetaType } from './types'

/**
 * @param start
 * @param end
 * @example getRangeArr(1, 5) = [1, 2, 3, 4, 5]
 */
export const getRangeArr = (start: number, end: number): number[] => {
	let cursor = start
	return [cursor, ...new Array(end - start).fill(null).map(() => ++cursor)]
}

export const safeParseJsonValue = <T>(candidate: string, defaultValue: T): T => {
	try {
		return JSON.parse(candidate) as T
	} catch (err) {
		console.error('Fail to parse json value ', candidate)
		return defaultValue
	}
}

export const getHeadPropsFromPageMeta = (
	pageMeta: PageMeta[]
): React.ComponentProps<typeof Head> => {
	const getMeta = (type: PageMetaType) => pageMeta.find((m) => m.role === type)?.value
	return {
		title: getMeta(PageMetaType.Title)!,
		description: getMeta(PageMetaType.Description),
		ogDescription: getMeta(PageMetaType.OgDesc),
		ogImageName: getMeta(PageMetaType.OgImageSource),
		ogTitle: getMeta(PageMetaType.OgTitle),
		canonicalLink: getMeta(PageMetaType.CanonicalLink),
	}
}
